var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { appColors } from '../assets/appColors';
export var BackrsCard = function (_a) {
    var children = _a.children, sx = _a.sx, onClick = _a.onClick;
    return (_jsx(Box, { onClick: onClick, sx: __assign(__assign(__assign({}, cardStyle), sx), { cursor: onClick ? 'pointer' : 'default', boxSizing: 'border-box' }), children: children }));
};
var cardStyle = {
    borderRadius: 2,
    p: 3,
    backgroundColor: appColors.neutral.white,
};
